import { EMOTIONS_STATIC_PATH_V2 } from "@/api/staticPaths";

export const ZOOM_STEP = 5;
export const ZOOM_MIN = 1;
export const ZOOM_MAX = 200;

export const EMOTIONS_PATHS = [
    `${EMOTIONS_STATIC_PATH_V2}emote1.png`,
    `${EMOTIONS_STATIC_PATH_V2}emote2.png`,
    `${EMOTIONS_STATIC_PATH_V2}emote3.png`,
    `${EMOTIONS_STATIC_PATH_V2}emote4.png`,
    `${EMOTIONS_STATIC_PATH_V2}emote5.png`,
];
